/**
 * Parent portal paths (#268). Browser-safe: no imports, so the API can use it with
 * a `.js` extension and the sign-in page can use it too.
 */

export const PARENT_SIGN_IN_PATH = '/parent/sign-in';

/**
 * #393: the school recorded the plan without a parent signature. Parents can still open and
 * read it (it is their child's current plan), but are not offered sign or comment.
 */
export const SIGNATURE_REFUSED = 'signature-refused';
export const RECORDED_WITHOUT_SIGNATURE_MESSAGE = 'The school has recorded this plan without a signature.';

/** Whether the parent page offers the sign / comment section for this status. */
export const parentResponseOpen = (status: string | null | undefined): boolean =>
  !!status && status !== 'signed' && status !== 'completed' && status !== SIGNATURE_REFUSED;

/** Only paths inside the parent portal may be used as the post-sign-in destination. */
export function safeParentNext(next: unknown): string {
  if (typeof next !== 'string') return '/parent';
  if (!/^\/parent(\/document\/[0-9a-f-]{36})?$/i.test(next)) return '/parent';
  return next;
}

/** Link for a parent email: the sign-in page, then straight on to the document. */
export function parentSignInLink(documentId?: string): string {
  if (!documentId) return PARENT_SIGN_IN_PATH;
  return `${PARENT_SIGN_IN_PATH}?next=${encodeURIComponent(`/parent/document/${documentId}`)}`;
}

const FAMILY_DOCUMENT_LABELS: Record<string, string> = {
  'action-plan': 'Action Plan',
  plp: 'Personalised Learning Plan',
  'monitor-review': 'Monitor & Review',
};

/** Plain name for a document type in a family-facing email. Never includes the student. */
export function familyDocumentLabel(documentType: string | null | undefined): string {
  return (documentType && FAMILY_DOCUMENT_LABELS[documentType]) || 'document';
}
